import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const fetchAllInvoices = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INVOICES.GET_ALL,
    params: {
      coll: params.coll,
      useAggregate: params.useAggregate,
      fil: JSON.stringify(params.filters),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      incl: params.incl,
      pg: params.page,
      cache: false,
      sort: params.sort ? JSON.stringify(params.sort) : JSON.stringify({ uiid: -1 })
    },
  });
};
export const fetchInvoicesByUiid = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INVOICES.GET_BY_UIID,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      incl: params.incl,
      pg: params.page,
      cache: false,
    },
  });
};
export const addInvoicesApi = async (coll, payload,postActions) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INVOICES.ADD_NEW,
    data: {
      coll: coll,
      payload: payload,
      // syncToQb:true,
      postActions:postActions,
    },
  });
};
export const updateInvoice = async ({
  coll,
  uiid,
  payload,
  patchId,
  tPath,
  syncFromQB,
  qbId
}) => {
  console.log("coll",coll,uiid,payload,patchId,tPath)
  const params = {
    coll,
    uiid,
    ...(syncFromQB && { syncFromQB }),
    ...(qbId && { qbId }),
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.INVOICES.UPDATE,
    data: { payload },
    params,
  });
};
